<template>
	<v-dialog v-model="show" fullscreen persistent>
		<v-card>
			<v-toolbar dark color="secondary">
				<v-card-title>
					<i class="fab fa-wpforms"></i>
					<span class="heradline ml-2">Attach Custom Form</span>
				</v-card-title>
				<v-spacer></v-spacer>
				<button
					type="button"
					class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
					@click="close"
				>
					<i class="fal fa-times"></i>
				</button>
			</v-toolbar>
			<v-card-text>
				<v-row>
					<v-col>
						<vue-select
							id="customForm"
							v-model="form.selected_custom_form"
							:options="customForms"
							label="name"
							v-validate="'required'"
							:filterable="false"
            :reduce="(customForm) => customForm.id"
							@search="searchCustomForms"
							@input="fetchCustomForm"
							name="customForm"
							:loading="loadings.custom_form"
						>
						</vue-select>
						<span class="kt-font-danger validate-error" v-show="errors.has('customForm')">
							{{ errors.first('customForm') }}
						</span>
					</v-col>
				</v-row>
				<div
					v-if="!isEmpty(customForm)"
					v-for="(question, index) in customForm.questions"
					:key="question.id"
				>
					<v-row>
						<v-col>
							<p style="font-size: 15px; color: black">
								{{ index + 1 }}. {{ question.question }}
							</p>
						</v-col>
					</v-row>
					<v-row v-if="question.type === 'single'">
						<v-text-field></v-text-field>
					</v-row>
					<v-row v-else-if="question.type === 'multiple'">
						<v-col v-for="answer in question.answers" :key="answer.id">
							<v-checkbox>
								<template v-slot:label>
									{{ answer.answer }}
								</template>
							</v-checkbox>
						</v-col>
					</v-row>
					<v-row v-else>
						<v-radio-group
							row
							v-validate="'required'"
							v-model="question.user_answer"
							:name="`answer.${index}`"
						>
							<v-col v-for="answer in question.answers" :key="answer.id">
								<v-radio :label="answer.answer" :value="answer.id"> </v-radio>
							</v-col>
						</v-radio-group>

						<p
							class="kt-font-danger validate-error"
							v-show="errors.has(`answer.${index}`)"
						>
							Please select an answer
						</p>
					</v-row>
				</div>
        <v-skeleton-loader
        v-if="loadings.attached_custom_form"
        type="article, article, article, article, article"
        >
        </v-skeleton-loader>
				<v-row>
					<v-col>
						<v-btn @click="attachCustomForm" color="blue text--white" style="color:white !important"> Save </v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { debounce as _debounce, isEmpty as _isEmpty, findIndex as _findIndex } from 'lodash-es';

export default {
  name: 'AttachCustomForm',
  props: {
    value: {
      default: false,
    },
    internetShop: {
      default: {},
    },
  },
  data() {
    return {
      isEmpty: _isEmpty,
      form: {
        selected_custom_form: null,
      },
      keywords: {
        custom_form: null,
      },
      loadings: {
        custom_form: false,
        attached_custom_form: false,
      },
      customForms: [],
      customForm: {},
      userAnswers: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.fetchCustomForms();
      }
    },
  },
  methods: {
    searchCustomForms: _debounce(function (customForm) {
      this.keywords.custom_form = customForm;
      this.fetchCustomForms();
    }, 500),
    async fetchCustomForms() {
      this.loadings.custom_form = true;
      const params = new URLSearchParams([['keyword', this.keywords.custom_form]]);

      await this.axios
        .get('v3/internet-shops/custom-forms', { params })
        .then(({ data }) => {
          this.customForms = data.data.data;

          this.$nextTick(() => {
            this.loadings.custom_form = false;
            this.fetchAttachedCustomForms();
          });
        });
    },
    fetchCustomForm(id) {
      this.axios.get(`v3/internet-shops/custom-forms/${id}`).then(({ data }) => {
        this.customForm = data.data;
        this.userAnswers = [];
      });
    },
    setAttachedCustomForm(custom_form) {
      const index = _findIndex(this.customForms, { id: custom_form.id });
      if (index === -1) {
        this.customForms.push(custom_form);
      }

      this.customForm = custom_form;

      this.form.selected_custom_form = custom_form.id;
    },
    fetchAttachedCustomForms() {
      if (_isEmpty(this.internetShop)) {
        this.loadings.attached_custom_form = false;

        return;
      }

      this.loadings.attached_custom_form = true;

      this.axios
        .get(`v3/internet-shops/${this.internetShop.id}/custom-forms`)
        .then(({ data }) => {
          if (!_isEmpty(data.data.custom_form)) {
            this.setAttachedCustomForm(data.data.custom_form);
          }

          this.loadings.attached_custom_form = false;
        })
        .catch(() => {
          this.loadings.attached_custom_form = false;
        });
    },
    attachCustomForm() {
      const custom_form = this.customForm;

      this.axios
        .post(`v3/internet-shops/${this.internetShop.id}/custom-forms`, {
          custom_form,
        })
        .then(({ data }) => {
          this.$notify('success', 'Custom form attached!');
          this.close();
        });
    },
    close() {
      // reset state
      this.show = false;
      this.customForms = [];
      this.customForm = [];
      this.userAnswers = [];
      this.form.selected_custom_form = null;
      this.$validator.reset();
      this.loadings.attached_custom_form = false;
      this.loadings.custom_form = false;
    },
  },
};
</script>
